"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  media: _propTypes2.default.object,
  _mediaSetters: _propTypes2.default.object,
  _mediaGetters: _propTypes2.default.object
};
module.exports = exports["default"];